/*eslint no-script-url: 0 */
import React, { Component } from 'react';
import { Tab, Nav, NavItem } from 'react-bootstrap';
import Frames from './Frames';
import Mats from './Mats';
import Backing from './Backing';
import Glass from './Glass';
import WallColor from './WallColor';
import RoomView from './RoomView';
import Printing from './Printing';

class Tabs extends Component {

  constructor(props, context) {
    super(props, context);

    this.handleSelect = this.handleSelect.bind(this);
  }

  handleSelect(key) {
    this.props.dispatch({
      type: 'SET_STATE',
      state: {
        selectedTab: key
      }
    })
  }

  render() {
    return (
      <div className="attr_sect full_width">
        <div className="container">
          <div className="row">
            <div className="col-sm-12">
              <Tab.Container className="tab_1" activeKey={this.props.selectedTab} defaultActiveKey="frames" id="tab-container-frame" onSelect={this.handleSelect}>
                <div className="tabbable-panel">
                  <div className="tabbable-line">
                    <Nav bsStyle="tabs">
                      <NavItem eventKey="frames">Frames</NavItem>
                      <NavItem eventKey="mats">Mats</NavItem>
                      <NavItem eventKey="backing">Backing</NavItem>
                      <NavItem eventKey="glass">Glass</NavItem>
                      <NavItem eventKey="printing">Printing</NavItem>
                      <NavItem eventKey="wallcolor">Wall Colour</NavItem>
                      <NavItem eventKey="roomview">Room View</NavItem>
                    </Nav>                    
                    <div className="tab-content">
                      <div className="tab-pane active">
                        <div className="in_tabs">
                          <div className="tab-content">
                            <div className="tab-pane active tb_cont" id="all">
                              <Tab.Content>
                                <Tab.Pane eventKey="frames">
                                  <Frames {...this.props} />
                                </Tab.Pane>
                                <Tab.Pane eventKey="mats">
                                  <Mats {...this.props} />
                                </Tab.Pane>
                                <Tab.Pane eventKey="backing">
                                  <Backing {...this.props} />
                                </Tab.Pane>
                                <Tab.Pane eventKey="glass">
                                 <Glass {...this.props} />
                                </Tab.Pane>
                                <Tab.Pane eventKey="printing">
                                  <Printing {...this.props} />
                                </Tab.Pane>
                                <Tab.Pane eventKey="wallcolor">
                                  <WallColor {...this.props} />
                                </Tab.Pane>
                                <Tab.Pane eventKey="roomview">
                                  <RoomView {...this.props} />
                                </Tab.Pane>
                              </Tab.Content>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Tab.Container>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default Tabs;